import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import './new.css';
import { FaStar, FaShoppingCart } from "react-icons/fa";
import Gallery from './gallery'
import ReviewSection from './ReviewSection';
import RoomSuggestion from './RoomSuggestion';
import HomeCarousel from '../../Component/HomeCarousel/HomeCarousel';
const Product = () => {
  const { id } = useParams();
  const images = [
    "https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/20150819123345686-976e1f5f-d5ee-41ce-8026-02b6c7749bac.jpg",
    "https://media.designcafe.com/wp-content/uploads/2020/09/25151904/2bhk-apartment-living-room-interior-design.jpg",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsvBrjdxH9WtvqSZJHtuX-6zarEG7226whMw&s",
  ];

  const [mainImage, setMainImage] = useState(images[0]);
  const [roomType, setRoomType] = useState("");
  const [personalMessage, setPersonalMessage] = useState("");

  return (
    <div>
    <div className="hotel-page">
      <div className="hotel-container">
        {/* Left Section: Image Gallery */}
        <div className="image-gallery">
          <img src={mainImage} alt="Main Hotel" className="main-image" />
          <div className="thumbnails">
            {images.map((img, index) => (
              <img 
                key={index} 
                src={img} 
                alt={`Thumbnail ${index + 1}`} 
                className="thumbnail" 
                onClick={() => setMainImage(img)} 
              />
            ))}
          </div>
        </div>

        {/* Right Section: Details */}
        <div className="hotel-details">
          <h2>Delite Sarovar Portico Faridabad <span>★★★★☆</span></h2>
          <p className="price">USD <strong>36.32</strong></p>

          <label>Room Type:</label>
          <select value={roomType} onChange={(e) => setRoomType(e.target.value)}>
            <option value="">Select an option</option>
            <option value="Deluxe">Deluxe Room</option>
            <option value="Suite">Luxury Suite{id}</option>
          </select>

          <label>Personalized Message (optional):</label>
          <textarea 
            placeholder="E.g., Happy Anniversary! Love, John"
            value={personalMessage}
            onChange={(e) => setPersonalMessage(e.target.value)}
          ></textarea>

          <button className="add-to-cart">
            <FaShoppingCart /> Add to Cart
          </button>

          <p className="stock-status">✔ In Stock - Book now!</p>

          {/* Reviews */}
          <div className="reviews">
            <p><FaStar /> 4.8 (3,598 reviews)</p>
            <small>Multiple people gave 5-star reviews in the past 7 days.</small>
          </div>
        </div>
      </div>
      
    </div>
    <div className=' rewiw_row '>
    <div className=''>
    <Gallery/>
    <ReviewSection />
    </div>
  
    <RoomSuggestion />
    </div>
    <HomeCarousel />
    </div>
  );
};

export default Product;